import { useCoreboundHelp } from './CoreboundHelp';
import './CoreboundTip.css';

const CoreboundTip = ({
  id,
  title,
  children,
  floating = false,
  action = 'Got it',
}) => {
  const { isTipVisible, dismissTip, setTipsEnabled } = useCoreboundHelp();
  if (!isTipVisible(id)) return null;
  return (
    <aside
      className={`coreboundContextTip ${floating ? 'is-floating' : ''}`}
      aria-label={title}
      aria-live="polite"
      onPointerDown={(event) => event.stopPropagation()}
      onKeyDown={(event) => {
        // Space on a tip button must not spend a board bump or charge a throw.
        event.stopPropagation();
      }}
    >
      <span className="coreboundContextTipKicker">QUICK TIP</span>
      <h3>{title}</h3>
      <div className="coreboundContextTipBody">{children}</div>
      <div className="coreboundContextTipActions">
        <button type="button" onClick={() => setTipsEnabled(false)}>
          Skip tips
        </button>
        <button type="button" onClick={() => dismissTip(id)}>
          {action}
        </button>
      </div>
    </aside>
  );
};

export default CoreboundTip;
